import React from 'react';
import { Popconfirm, PopconfirmProps } from 'components';
import ReplaceAgreementText from '../ReplaceAgreementText';

interface ConfirmReplaceProps extends Partial<PopconfirmProps> {
  open: boolean;
  onOpenChange: (visible: boolean) => void;
  handleConfirm: () => void;
  isRestore?: boolean;
}

const ConfirmReplace: React.FC<ConfirmReplaceProps> = ({
  open,
  onOpenChange,
  handleConfirm,
  isRestore,
  ...props
}) => (
    <Popconfirm
      title={<ReplaceAgreementText isRestore={isRestore} />}
      placement="left"
      width={320}
      overlayStyle={{ zIndex: 2000 }}
      getPopupContainer={el => el.parentElement}
      onOpenChange={onOpenChange}
      onCancel={() => onOpenChange(false)}
      onConfirm={handleConfirm}
      okText="Replace"
      open={open}
      {...props}
    />
  );

export default ConfirmReplace;
